import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import { getTenant } from 'services/api/AccessManagerAPI';

export const useGetTenant = (id = '') => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.tenant(id),
        queryFn: () => getTenant(id),
        enabled: !!id,
    });

    return { tenantData: data, isTenantLoading: isLoading, ...rest };
};
